import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { SCAN_CLAIM_PRIZES } from '../utils/scanClaimUi';

export default function ScanClaimPrizeList({ titleStyle, itemStyle, textStyle }) {
  return (
    <>
      <Text style={titleStyle}>Serta kesempatan memenangkan</Text>
      {SCAN_CLAIM_PRIZES.map((prize) => (
        <View key={prize.label} style={[itemStyle, styles.row]}>
          <Text style={styles.emoji}>{prize.emoji}</Text>
          <Text style={textStyle}>{prize.label}</Text>
        </View>
      ))}
      <Text style={[titleStyle, styles.footnote]}>
        Semakin banyak scan, semakin besar peluang menang ✨
      </Text>
    </>
  );
}

const styles = StyleSheet.create({
  row: {
    alignItems: 'center',
  },
  emoji: {
    width: 28,
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 22,
  },
  footnote: {
    marginTop: 8,
    marginBottom: 0,
  },
});
